import styled from "styled-components"

const ResultType = styled.div`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
  & ~ h4,
  & ~ p {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`
const ResultItems = styled.article`
  &:not(:last-child) {
    border-bottom: 5px solid
      ${(props) => props.theme.a_color_gradients.a_medium};
  }
`
const Article = styled.article`
  border-bottom: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
`

export { ResultItems, ResultType, Article }
